import { useForm } from "react-hook-form";

import useDebugable from "./useDebug";

export interface FreeFortuneFormData {
  theme: string;
  themeConfirm: string;
  answer: string;
  answerConfirm: string;
  birthday: string;
  birthdayConfirm: string;
  bloodtype: string;
  bloodtypeConfirm: string;
  partnerBirthday: string;
  partnerBirthdayConfirm: string;
  name: string;
  nameConfirm: string;
}

export const useFreeFortuneForm = () => {
  const { defaultFormValues: debugableValues } = useDebugable({
    eager: false,
    showAll: false,
  });
  const form = useForm<FreeFortuneFormData>({ defaultValues: debugableValues });

  return {
    form,
  };
};
